<div class="content">
    <button class="btn-icon close" (click)="this.dialogRef.close()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="image-wrapp flex-center">
        <img src="../../../../../assets/images/AdCreator/ad_confirm.svg" alt="">
    </div>
    <h1>CONGRATULATIONS</h1>
    <p>Your ad <span>has been</span> promoted.</p>
</div>